import { render, staticRenderFns } from "./AppsMenuWindow.vue?vue&type=template&id=9382f6a4&scoped=true"
import script from "./AppsMenuWindow.vue?vue&type=script&lang=js"
export * from "./AppsMenuWindow.vue?vue&type=script&lang=js"
import style0 from "./AppsMenuWindow.vue?vue&type=style&index=0&id=9382f6a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9382f6a4",
  null
  
)

export default component.exports